module.exports = __webpack_public_path__ + "eeda71cc5b8aaa6b305e32dc79aecd2b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/fonts/freeplay.eot
// module id = ./src/styles/icons/fonts/freeplay.eot
// module chunks = 0